import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../../core/services/api.service';
import { GenerateEvQrResponse } from '../../../../../core/models/ev.model';
import { InputComponent } from '../../../../../tools/forms/input/input.component';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ToastService } from 'angular-toastify';


@Component({
  selector: 'app-generate-ev-qr',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent
  ],
  templateUrl: './generate-ev-qr.component.html',
  styleUrl: './generate-ev-qr.component.css'
})
export class GenerateEvQrComponent implements OnInit {
  evQrs: GenerateEvQrResponse[] = [];

  // --- Search & Sort State ---
  searchText: string = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' | '' = '';

  // Pagination state
  currentPage = 1;
  pageSize = 10;


  // Loading
  isLoading: boolean = false;





  constructor(
    private apiService: ApiService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.getEvQrList();
  }



  /* -------------------------------------------- Function --------------------------------------------*/

  // --------------- Sort Helper ---------------
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.currentPage = 1;
  }

  // Table Logic
  get filteredAndPaginatedData() {
    let data = [...this.evQrs];

    if (this.searchText) {
      const search = this.searchText.toLowerCase();
      data = data.filter(c =>
        (c.siteEvName || '').toLowerCase().includes(search) ||
        (c.spaceName || '').toLowerCase().includes(search) ||
        (c.qrUrl || '').toLowerCase().includes(search) ||
        (c.qrCode || '').toLowerCase().includes(search)
      );
    }

    // Sort
    if (this.sortColumn && this.sortDirection) {
      const direction = this.sortDirection === 'asc' ? 1 : -1;

      data.sort((a: any, b: any) => {
        switch (this.sortColumn) {
          case 'id':
            return (a[this.sortColumn] - b[this.sortColumn]) * direction;

          case 'created_at':
          case 'updated_at':
            const dateA = a[this.sortColumn] ? new Date(a[this.sortColumn]).getTime() : 0;
            const dateB = b[this.sortColumn] ? new Date(b[this.sortColumn]).getTime() : 0;
            return (dateA - dateB) * direction;

          default:
            const valA = (a[this.sortColumn] || '').toString().toLowerCase();
            const valB = (b[this.sortColumn] || '').toString().toLowerCase();
            return valA.localeCompare(valB, 'th', { numeric: true, sensitivity: 'base' }) * direction;
        }
      });
    } else {
      // Default Sort by created_at descending (newest first)
      data.sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateB - dateA;
      });
    }

    const start = (this.currentPage - 1) * this.pageSize;
    return data.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    let data = this.evQrs;

    if (this.searchText) {
      const search = this.searchText.toLowerCase();
      data = data.filter(c =>
        (c.siteEvName || '').toLowerCase().includes(search) ||
        (c.spaceName || '').toLowerCase().includes(search) ||
        (c.qrUrl || '').toLowerCase().includes(search) ||
        (c.qrCode || '').toLowerCase().includes(search)
      );
    }

    if (this.pageSize === 0) return 0;
    return Math.ceil(data.length / this.pageSize);
  }

  get pagesArray() {
    const total = this.totalPages;
    const maxVisibleButtons = 5;

    let startPage = Math.max(1, this.currentPage - 2);
    let endPage = Math.min(total, startPage + maxVisibleButtons - 1);

    if (endPage - startPage < maxVisibleButtons - 1) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  setPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  onPageSizeChange(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.pageSize = Number(element.value);
    this.currentPage = 1;
  }

  /* --- Actions --- */
  onSearch(value: string) {
    this.searchText = value;
    this.currentPage = 1;
  }

  onClickSearch() {
    this.currentPage = 1;
    this.getEvQrList();
  }

  onRefresh() {
    this.searchText = '';
    this.currentPage = 1;
    this.getEvQrList();
  }

  /* --- Modal Actions --- */


  /* -------------------------------------------- API --------------------------------------------*/
  getEvQrList() {
    this.isLoading = true;
    this.apiService.getGenerateEvQr('', '').subscribe({
      next: (res) => {
        //console.log('Response getGenerateEvQr :', res);
        this.evQrs = res;
        this.isLoading = false;
        this.currentPage = 1;
      },
      error: (err) => {
        console.error('Error fetching EV QRs:', err);
        this.toast.error('ไม่สามารถโหลดข้อมูล QR ได้');
        this.isLoading = false;
      }
    });
  }
}
